import { useState } from 'react';
import { AccountId, UserId } from 'api/models';
import { Filter, NotificationStatus } from 'api/notifications';
import { useAccount } from 'hooks/use-account';
import { useUser } from 'hooks/use-user';
import { useNotificationsStore } from 'stores/notifications';

export const useListState = (filter: Filter) => {
  const [status, setStatus] = useState(NotificationStatus.New);
  const info = useUser();
  const account = useAccount();
  const accountId = AccountId(account.accountId);
  const userId = UserId(info.user.userId);
  const { refresh, content } = useNotificationsStore(
    status,
    filter,
    accountId,
    userId,
    status === NotificationStatus.New && filter === Filter.All,
  );

  return {
    status,
    setStatus,
    refresh,
    content,
  };
};
